import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import "./Index.css"
import { faCalendar, faCalendarWeek, faCreditCard, faHourglass, faMoneyBill, faPlay, faStop, faStopCircle, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import ModalAdd from "./ModalAdd";
import ModalAddTrial from "./ModalAddTrial";
import ModalPay from "./ModalPay";
import { format, differenceInDays, differenceInCalendarDays, parseISO } from "date-fns";
import SrvButton from "../../../components/global/SrvButton";
import { transactionSet } from '../../../reducers/models/billing'
import ErrorAdd from "../../../util/ErrorAdd";


function Index() {
    const dispatch = useDispatch()

    const stateBilling = useSelector((state) => state.billing);//Billing

    const [logPay, setLogPay] = useState(null);

    const [modalAddShow, setModalAddShow] = useState(false);
    const [modalAddTrialShow, setModalAddTrialShow] = useState(false);
    const [modalPayShow, setModalPayShow] = useState(false);
    const [modalChangeShow, setModalChangeShow] = useState(false);

    const queryParameters = new URLSearchParams(window.location.search)

    useEffect(() => {
        if (stateBilling.transaction === null) {
            axios.get('/api_tracker/billing/tBankTransactionNoPayList')
                .then((res) => {
                    if (res.data.Status === 1) {
                        dispatch(transactionSet({ data: res.data.Data }))
                    }
                    else {
                        //setLog(res.data.Error);
                        //setLoading(false);
                    }
                })
                .catch((err) => {
                    //setLog('Неизвестная ошибка!');
                    //setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }
    }, []);



    return (
        <>
            {modalPayShow === true && (
                <ModalPay show={modalPayShow} onHide={() => setModalPayShow(false)} />
            )}
            {modalAddShow === true && (
                <ModalAdd show={modalAddShow} onHide={() => setModalAddShow(false)} />
            )}

            {modalAddTrialShow === true && (
                <ModalAddTrial show={modalAddTrialShow} onHide={() => setModalAddTrialShow(false)} />
            )}

            <div className='admin_content'>
                <div className="row">
                    <div className="col-lg-6">
                        {stateBilling.company === null ? (
                            <div className="card p-3 block_subscription">
                                <div className="title">
                                    <i className="mr-10"><FontAwesomeIcon icon={faStopCircle} /></i>
                                    Компания не активирована
                                </div>
                                <div className="d-flex mt-15">
                                    <div className="mr-10">
                                        <SrvButton typeBtn="pay" size={'sm'} textBtn='Активировать' onClick={() => { setModalAddShow(true) }} />
                                    </div>
                                    <div>
                                        <SrvButton typeBtn="play" size={'sm'} textBtn='Активировать пробный период' onClick={() => { setModalAddTrialShow(true) }} />
                                    </div>
                                </div>
                            </div>
                        ) :
                            (
                                <div className="card p-3 block_subscription mb-3">
                                    <div className="title">
                                        {stateBilling.company.ID_Status === 0 && <i className="mr-10"><FontAwesomeIcon icon={faPlay} /></i>}
                                        {stateBilling.company.ID_Status === 1 && <i className="mr-10"><FontAwesomeIcon icon={faPlay} /></i>}
                                        {stateBilling.company.Name_Status}
                                    </div>
                                    <div className="mt-10">
                                        {stateBilling.company.Days_Left > 0 ? (
                                            <div className="info">
                                                Оплачено до: {format(new Date(stateBilling.company.Date_End), 'dd.MM.yyyy')}г  (осталось {stateBilling.company.Days_Left}дн.)
                                            </div>
                                        ) : (
                                            <div className="info-danger">
                                                Требуется оплата
                                            </div>
                                        )}
                                        <div className="info">
                                            Активные пользователи: {stateBilling.company.Count_User}
                                        </div>
                                    </div>
                                    {stateBilling.company.ID_Status !== 0 && (
                                        <div className="mt-10 row">
                                            <div className="col-lg-6">
                                                <div className="block_subscription_price">
                                                    <div className="name">Стоимость:</div>
                                                    <div className="price">{stateBilling.company.Tariff_Base * stateBilling.company.Count_User * 30}р/мес</div>
                                                </div>
                                                <div className="block_subscription_price">
                                                    <div className="name">Скидка:</div>
                                                    <div className="price">{(stateBilling.company.Discount_User_Percent + stateBilling.company.Discount_Period_Percent) > 0 ? (<>{stateBilling.company.Discount_User_Percent + stateBilling.company.Discount_Period_Percent}%</>) : 'Без скидки'}</div>
                                                </div>
                                                <div className="block_subscription_price">
                                                    <div className="name">ИТОГО:</div>
                                                    <div className="price">{stateBilling.company.Tariff * stateBilling.company.Count_User * 30}р/мес</div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6" style={{ textAlign: 'right' }}>
                                                <SrvButton typeBtn="pay" size={'lg'} onClick={() => setModalPayShow(true)} />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                    </div>
                    <div className="col-lg-6">
                        {stateBilling.company !== null && (
                            <>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="card-shadow-primary mb-3 widget-chart widget-chart2 text-start card animated fadeInUp">
                                            <div className="widget-chat-wrapper-outer">
                                                <div className="widget-chart-content">
                                                    <h6 className="widget-subheading">БАЛАНС</h6>
                                                    <div className="widget-chart-flex">
                                                        <div className="widget-numbers mb-0 w-100">
                                                            <div className="widget-chart-flex">
                                                                <div className="fsize-4">
                                                                    {stateBilling.company.Balance}
                                                                    <small className="opacity-5">р</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="card-shadow-primary mb-3 widget-chart widget-chart2 text-start card animated fadeInUp">
                                            <div className="widget-chat-wrapper-outer">
                                                <div className="widget-chart-content">
                                                    <h6 className="widget-subheading">БОНУСЫ</h6>
                                                    <div className="widget-chart-flex">
                                                        <div className="widget-numbers mb-0 w-100">
                                                            <div className="widget-chart-flex">
                                                                <div className="fsize-4">
                                                                    {stateBilling.company.Balance_Bonus}
                                                                    <small className="opacity-5">р</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>


                {stateBilling.transaction !== null && (
                    stateBilling.transaction.map(item => (
                        <div key={item.PaymentId} className="row list_item mt-15 param_row" >
                            <div className="col-lg-3 title d-flex align-items-center" >
                                Ожидает оплаты
                            </div>

                            <div className="col-lg-3 d-flex align-items-center justify-content-lg-center">
                                <div>
                                    <i className="mr-5"><FontAwesomeIcon icon={faUsers} /></i>
                                    Пользователи: {item.Count_User}
                                    <br></br>
                                    <i className="mr-5"><FontAwesomeIcon icon={faCalendar} /></i>
                                    Кол-во месяцев: {item.Count_Month}
                                </div>
                            </div>
                            <div className="col-lg-3 d-flex align-items-center justify-content-lg-center fs-4">
                                {item.Amount / 100}р
                            </div>
                            <div className="col-lg-3 d-flex align-items-center justify-content-lg-right">
                                <a href={item.PaymentURL} className="payment_source_button param_button">
                                    <i className="mr-5"><FontAwesomeIcon icon={faCreditCard} /></i>
                                    Оплатить
                                </a>
                            </div>
                        </div>
                    ))

                )}
            </div >
        </>
    );
}

export default Index;
